export enum OtherRisk {
  TOBACCO = 'tobacco',
  OVERWEIGHT = 'overweight',
  DIABETES = 'diabetes',
  BLOOD_PRESSURE = 'bloodPressure',
  CHOLESTEROL = 'cholesterol',
  VITAMIN_DEFICIENCY = 'vitaminDeficiency',
  UNKNOWN = 'unknown',
}

export const otherRiskMapping = {
  [OtherRisk.TOBACCO]: $localize`:@@common_otherRisk_tobacco:Tobacco`,
  [OtherRisk.OVERWEIGHT]: $localize`:@@common_otherRisk_overweight:Overweight`,
  [OtherRisk.DIABETES]: $localize`:@@common_otherRisk_diabetes:Diabetes`,
  [OtherRisk.BLOOD_PRESSURE]: $localize`:@@common_otherRisk_bloodPressure:Blood pressure`,
  [OtherRisk.CHOLESTEROL]: $localize`:@@common_otherRisk_cholesterol:Cholesterol`,
  [OtherRisk.VITAMIN_DEFICIENCY]: $localize`:@@common_otherRisk_vitaminDeficiency:Vitamin Deficiency`,
  [OtherRisk.UNKNOWN]: $localize`:@@common_otherRisk_unknown:Unknown`,
};
